import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Wrench, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * TechShell — minimal mobile-first chrome for maintenance staff.
 * No sidebar. Single top bar with logout + name. Everything else lives
 * in the child routes so the tech's phone screen isn't cluttered.
 */
export default function TechShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <div className="min-h-screen bg-zinc-950 text-white" data-testid="tech-shell">
      {/* Top bar — sticky so techs always know where they are */}
      <header className="sticky top-0 z-10 border-b border-white/10 bg-zinc-950/90 backdrop-blur">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button
            onClick={() => nav("/tech")}
            className="flex items-center gap-2 min-w-0"
            data-testid="tech-home-link"
          >
            <div className="h-8 w-8 rounded-md bg-orange-500 flex items-center justify-center shrink-0">
              <Wrench className="h-4 w-4 text-white" />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-widest text-orange-400">Tech</div>
              <div className="text-sm font-medium truncate">{user?.name || "Maintenance"}</div>
            </div>
          </button>
          <div className="flex-1" />
          {loc.pathname !== "/tech" && (
            <Button size="sm" variant="ghost" onClick={() => nav("/tech")}
                    className="text-white/80 hover:text-white hover:bg-white/10"
                    data-testid="tech-back-btn">
              Back
            </Button>
          )}
          <Button size="sm" variant="ghost" onClick={logout}
                  className="text-white/60 hover:text-white hover:bg-white/10"
                  data-testid="tech-logout-btn">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-4 pb-24">
        <Outlet />
      </main>
    </div>
  );
}
